// extracted by mini-css-extract-plugin
export default {"master":"banner_master__NWZES"};